import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';
import { CollaboratoreDTO } from '../domain/collaboratore';
import { EventoDTO } from './evento';

export class CategoriaEventoDTO extends LogicalDeleteDTO {
    id: number;
    tenant: TenantDTO;
    nome: string;
}